import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: string;
    error: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for the folder access toggle */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderAccessToggle.title?c=rh3djn0viyad", defaultMessage: "Make Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for the folder access toggle */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderAccessToggle.description?c=p61rk4sa970e", defaultMessage: "Only people directly invited to this folder will have access, plus admins." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message for the folder access toggle */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "FolderAccessToggle.error?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
